import { useEffect } from 'react';

const BASE_URL = import.meta.env.VITE_API_URL || '/api';

/**
 * Sends a lightweight page view beacon to the backend.
 * Used on public pages (landing, login, super-admin-login) that don't
 * generate API calls and would otherwise be invisible in monitoring.
 *
 * Fire-and-forget — never blocks rendering or shows errors.
 *
 * @param {string} page - The page path to track (e.g., '/landing', '/login')
 */
export function usePageView(page) {
  useEffect(() => {
    if (!page) return;
    fetch(`${BASE_URL}/beacon`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ page, referrer: document.referrer || null }),
    }).catch(() => {});
  }, [page]);
}
